import script from "./CepaView.vue?vue&type=script&setup=true&lang=js"
export * from "./CepaView.vue?vue&type=script&setup=true&lang=js"

import "./CepaView.vue?vue&type=style&index=0&id=7ef1a4e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ef1a4e7"]])

export default __exports__